export default __webpack_public_path__ + "static/media/IMG_0277.a9d8bba1.jpeg";